// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"62a8f564","425":"725f9ed2","510":"ea79cf70","532":"414d80e7","633":"8489b4e1","634":"2503e0ae","922":"c2eb2e91","937":"d727ec35","972":"ccbae976"}[chunkId] + ".chunk.js";
};